import { api } from "./../../apiAxios";
import { removeToken } from "./../token";
import { removeRefreshToken, removeUsuario } from "./../UsuarioERefresh";

export const SairDoSistema = (): void => {
    removeToken();
    removeRefreshToken();
    removeUsuario();
    api.defaults.headers.common['Authorization'] = '';
}
